import React, { Component } from 'react';
import {getEffectTrack} from "utils/getEffectTrack.js";
import MessageComponent from "components/effects/messaging/MessageComponent.js";
import EffectBottomToolbar from './EffectBottomToolbar.js';
import Colors from 'components/Colors.js';
import {LIVE_FX, AUDIO_FX} from 'constants/effect-types.js';
import {dropPulledEffect} from './dropPulledEffect.js';
import '../../EffectPresets.scss';
import EffectPresets from './EffectPresets.js';
import { connect } from "react-redux";
import {
    deleteEffect,
    toggleEffect,
    moveEffect,
} from 'operations/actions.js';
import {
    setEffectStarred,
    setEffectCollapsed,
    setSelectedEffect,
    dragEffect,
    clearDragDrop,
    setPulledEffects,
    setLinkingEffects,
    setMidiEffectDragging,
    setContextualHelp} from 'actions/index.js';
import {EFFECT_TOGGLE_BUTTON} from 'constants/contextual-help.js';
import {EFFECT_PRESETS_BUTTON} from 'constants/contextual-help.js';
import {EFFECT_RETURN_PRESETS_BUTTON} from 'constants/contextual-help.js';
import {EFFECT_COLLAPSE_BUTTON} from 'constants/contextual-help.js';
import {EFFECT_DELETE_BUTTON} from 'constants/contextual-help.js';
import {PARAMETER_MODS_BUTTON} from 'constants/contextual-help.js';
import EffectMods from './EffectMods.js';
import EffectsComponent from 'components/effects/EffectsComponent.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import '../../Effects.scss';

const colors = new Colors();

/**
 * A wrapper that goes around all effects allowing deleting, dragging (moving)
 * and seeing mods
 */

class DeletableEffectComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showMods: false,
            isCollapsed: props.isMixCollapsed || props.isCollapsed,
            isDraggable: props.isDraggable !== undefined ? props.isDraggable : true,
            showPresets: false
        };

        this.togglePresets = this.togglePresets.bind(this);
    }

    togglePresets() {
        this.setState({
            showPresets: !this.state.showPresets
        });
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.isCollapsed !== this.props.isCollapsed) {
            this.state.isCollapsed = nextProps.isCollapsed;
        }
        return true;
    }

    toggleCollapsed() {
        if (this.props.effect.isEnabled()) {
            this.props.setEffectCollapsed(this.props.effect.id, !this.state.isCollapsed);
        }
    }

    deleteEffect() {
        if ((!this.props.instrument && !this.props.isPulled) ||
            (this.props.effect.track &&
             this.props.effect.track.tracks)) {
            this.operationManager.dispatch(
                deleteEffect(
                    this.props.effect,
                    this.props.track,
                    this.props.group,
                    this.props.send));
        } else {
        }
        if (this.props.onDeleteEffect) {
            this.props.onDeleteEffect(this.props.effect);
        }
    }

    handleToggle() {
        this.operationManager.dispatch(
            toggleEffect(
                this.props.effect,
                this.props.track,
                this.props.group,
                this.props.send));

        this.props.onToggle();
    }

    getTrackOrGroup() {
        return this.props.send || this.props.track || this.props.group;
    }

    get operationManager() {
        return this.props.sequencerEngine.operationManager;
    }

    getContextNumber() {
        return this.props.track !== undefined ?
            this.props.track.trackNumber :
            this.props.group !== undefined ?
            this.props.group.groupNumber :
            1;
    }

    onDragStart(e) {
        if (!this.state.isDraggable) {
            return;
        }
        if (this.props.automation || !this.getTrackOrGroup()) {
            return;
        }
        let effectNumber = this.getTrackOrGroup().getEffectNumber(
            this.props.effect,
            this.props.isMidiEffect);

        if (this.props.isLiveEffect || this.props.isMidiEffect) {
            this.props.clearDragDrop();
            this.props.dragMidiEffect({
                number: this.getContextNumber(),
                effectNumber: effectNumber,
                effect: this.props.effect
            });
        } else {
            this.props.clearDragDrop();
            this.props.dragEffect({
                number: this.getContextNumber(),
                effectNumber: effectNumber,
                effect: this.props.effect
            });
        }
    }

    setContextualHelp(e, contextualHelp) {
        e.stopPropagation();
        this.props.setContextualHelp(contextualHelp);
    }

    onDragOver(e) {
        if (!this.state.isDraggable) {
            return;
        }
        e.preventDefault();
    }

    onDrop(e) {
        if (this.props.featured) {
            let effectDragging = this.props.effectDragging || this.props.midiEffectDragging;
            if (!effectDragging) {
                return;
            }
            dropPulledEffect(this.props.effect, effectDragging.effect, this.props.sequencerEngine);
            this.props.dragEffect(undefined);
            this.props.dragMidiEffect(undefined);
            return;
        }

        if (!this.state.isDraggable) {
            return;
        }
        if (this.props.automation || !this.getTrackOrGroup()) {
            return;
        }
        if (this.props.effectDragging !== undefined) {
            let effectNumber = this.getTrackOrGroup().getEffectNumber(
                this.props.effect,
                this.props.isMidiEffect);
            if (this.props.isMidiEffect) {
                this.props.dragEffect(undefined);
                return;
            }
            if (this.props.effectDragging.number === this.getContextNumber()) {
                this.operationManager.dispatch(
                    moveEffect(
                        this.props.effectDragging.effectNumber, effectNumber,
                        false, // not midi effect
                        this.props.track,
                        this.props.group,
                        this.props.send));
            }
            this.props.dragEffect(undefined);
        } else if (this.props.midiEffectDragging !== undefined) {
            let effectNumber = this.getTrackOrGroup().getEffectNumber(this.props.effect, this.props.isMidiEffect);
            if (this.props.isMidiEffect &&
                this.props.midiEffectDragging.number === this.getContextNumber()) {
                this.operationManager.dispatch(
                    moveEffect(
                        this.props.midiEffectDragging.effectNumber, effectNumber,
                        true, // is midi effect
                        this.props.track,
                        this.props.group,
                        this.props.send));
            }
            this.props.dragMidiEffect(undefined);
            this.props.dragEffect(undefined);
        } else {
            return;
        }

        this.props.onDeleteEffect();
    }

    getClassName(name) {
        return this.props.effect.isEnabled() ? name :
            name + ' disabled';
    }

    detachEffect(effect) {
        let state = this.props.sequencerEngine.state;
        let pulledEffects = [...state.effects.pulledEffects, this.props.effect];
        this.props.setPulledEffects(pulledEffects);
    }

    selectEffect(e) {
        e.stopPropagation();

        if (this.props.linkingEffects) {
            this.props.linkingEffects.effect.linkedEffect = this.props.effect;
            this.props.setLinkingEffects(undefined);
            return;
        }

        if (this.props.planeMapping && this.props.planeMapping !== this.props.effect) {
            this.setState({isMapped: true});
            this.props.planeMapping.randomlyMapParameters(this.props.effect);
        }

        return;
        let sequencerEngine = this.props.track ? this.props.track.sequencerEngine :
            this.props.effect.sequencerEngine;
        if (sequencerEngine && !this.props.noSelect) {
            sequencerEngine.selectEffect(this.props.effect);
        }
        if (!this.props.noSelect) {
            this.props.setSelectedEffect(this.props.effect.id);
        }
    }

    /**
     * props -> isTall: boolean that determines if the layout
     *   is tall (for effects with many parameters)
     * props -> children: the actual effect
    */
    render() {
        if (!this.props.effect.name) {
            return '';
        }
        let effectClass = this.props.isTall ? 'tall-effect effect' : 'effect';
        if (this.props.effectClass) {
            effectClass += ' ' + this.props.effectClass;
        }
        let className = this.props.automation !== undefined ?
            'enabled ' + effectClass + ' effect-automation' :
            this.props.effect.isEnabled() ? effectClass + ' enabled' :
            'effect disabled';

        if (this.props.isSelectedZObject) {
            className += " selected-zobject";
        }

        let isModuleMidi = false;
        if (this.props.effect && this.props.effect.track && this.props.effect.track.tracks) {
            isModuleMidi = true;
        }

        className += ' ' + this.props.effect.name.split(' ').join('_') + ' ' ;

        if (this.state.isCollapsed) {
            className += ' collapsed';
        }

        if (this.props.isSelected) {
            className += ' selected';
        }

        if (this.props.isMidiEffect) {
            className += ' midi';
        }

        if (this.props.isLiveEffect) {
            className += ' live';
        }

        if (this.props.effect.name === "Midi Effect Rack" ||
            this.props.effect.name === "Effect Rack") {
            className += ' racked';
        }
       

        if (this.props.effect.name === "Jaki") {
            className += " Jaki";
        }

        let headerClassName = "effect-header";
        if (this.props.hideBarButtons) {
            headerClassName += " hide-buttons";
        }

        if (this.props.planeMapping && this.props.planeMapping !== this.props.effect) {
            if (!this.state.isMapped) {
                className += " plane-mapping";
            }
        }
        if (this.props.linkingEffects &&
            this.props.effect.name === this.props.linkingEffects.name) {
            className += " plane-mapping";
        }

        if (this.props.effect.name === "Message") {
            return (<MessageComponent effect={this.props.effect}/>);
        }

        if (this.props.isPulled) {
            className += " pulled";
            return (
                <div
                  onDragStart={(e) => this.onDragStart(e)}
                  onDragOver={(e) => this.onDragOver(e)}
                  onDrop={(e)=>{this.onDrop(e)}}                   
                  draggable={this.state.isDraggable}
                  className={className}>
                <div className="effect-header">
                  {this.props.effect.name} 
                </div>
                  <div className="effect-inner">
                    <img src="/detached.svg" className="detached-icon"/>
                    <div className="detached-label">
                      Detached
                    </div>
                  </div>
                </div>
            );
        }

        const getEffectLocation = () => {
            let fx = this.props.effect;
            let track = getEffectTrack(fx); 
            if (!track) {
                return '';
            }
            return (
                <div style={{backgroundColor: track.color || colors.getColorForTrack(track)}} className="effect-from">
                {track.envelopesTrack ?
                 track.name :
                 track.getName()}
                </div>
            );
        };

        if (this.props.showStar) {
            headerClassName += " showing-star";
        }
        return (
            <div
              onClick={(e) => this.selectEffect(e)}
              onDragStart={(e) => this.onDragStart(e)}
              onDragOver={(e) => this.onDragOver(e)}
              onDrop={(e)=>{this.onDrop(e)}}                   
              draggable={!this.props.noSelect && this.state.isDraggable}
              className={className}>
              <div className={headerClassName}>
                <ConditionedComponent condition={!this.props.hideBarButtons}>
                  <div
                    onMouseOver={(e) => this.setContextualHelp(e, EFFECT_TOGGLE_BUTTON)}
                    onMouseLeave={() => this.props.setContextualHelp(undefined)}
                    onClick={() => this.handleToggle()}
                    className="effect-toggle">
                    <div className="toggle-icon"></div>
                  </div>
                  <div
                    onMouseOver={(e) => this.setContextualHelp(e, EFFECT_COLLAPSE_BUTTON)}
                    onMouseLeave={() => this.props.setContextualHelp(undefined)}
                    onClick={() => this.toggleCollapsed()}
                    className="collapse-toggle">
                    <ConditionedComponent condition={this.state.isCollapsed}>
                      <div className="arrow-down"></div>
                    </ConditionedComponent>
                    <ConditionedComponent condition={!this.state.isCollapsed}>
                      <div className="arrow-right"></div>
                    </ConditionedComponent>
                  </div>
                </ConditionedComponent>
                <ConditionedComponent condition={this.props.effect.isEnabled() && !this.state.isCollapsed}>
                  <div className="effect-name">{this.props.effect.name}</div>
                </ConditionedComponent>
                {this.props.featured && getEffectLocation()}
                {!this.props.featured ?
                 <img onClick={() => this.detachEffect()} src="/detached.svg" className="detach-effect-icon"/> : ""}
                {this.props.alternateButton || ''}
                <ConditionedComponent condition={!this.props.hideBarButtons && this.props.automation === undefined && !this.state.isCollapsed}>
                  {this.props.showStar &&
                   <div
                     onClick={() => this.props.setStarred(!this.props.isStarred)}
                     className={this.props.isStarred ? "starred star": "star"}>
                     <span>&#9734;</span>
                   </div>}
                  <div
                    onMouseOver={(e) => this.setContextualHelp(e, EFFECT_DELETE_BUTTON)}
                    onMouseLeave={() => this.props.setContextualHelp(undefined)}
                    className="effect-delete-btn delete-button"
                    onClick={() => this.deleteEffect()}>{!isModuleMidi && this.props.featured && !this.props.showDelete  ? '-' : 'x'}</div>
                </ConditionedComponent>
              </div>
              <ConditionedComponent condition={this.state.showPresets}>
                <EffectPresets
                  sequencerEngine={this.props.sequencerEngine}
                  trackNumber={this.props.track && this.props.track.trackNumber}
                  hide={() => this.setState({showPresets: false})}
                  effect={this.props.effect}/>
              </ConditionedComponent>
              <ConditionedComponent condition={!this.state.showPresets}>
                <div className="inner-effect">
                  <ConditionedComponent condition={!this.props.effect.isEnabled() || this.state.isCollapsed}>
                    <div className="effect-name">
                      {this.props.name || this.props.effect.name}
                    </div>
                    {getEffectLocation()}
                  </ConditionedComponent>
                  <div className="clear-fix"></div>
                  <ConditionedComponent condition={this.state.showMods}>
                    <EffectMods parameters={this.props.effect.parameters}/>
                  </ConditionedComponent>
                  <ConditionedComponent condition={!this.state.showMods && !this.state.isCollapsed && !this.state.showPresets}>
                    {this.props.children}
                  </ConditionedComponent>
                  <div className="clear-fix"/>
              </div>
              </ConditionedComponent>
            {!this.props.isLiveEffect &&
             <EffectBottomToolbar
               effect={this.props.effect}
               togglePresets={this.togglePresets}
               setContextualHelp={this.props.setContextualHelp}
               showPresets={this.state.showPresets}/>}
            </div> 
        );
    }
}

const mapDispatchToProps = (dispatch, props) => {
    return {
        setContextualHelp: (element) => dispatch(setContextualHelp(element)),
        dragEffect: effectNumber => dispatch(dragEffect(effectNumber)),
        dragMidiEffect: effectNumber => dispatch(setMidiEffectDragging(effectNumber)),
        setEffectCollapsed: (id, isCollapsed) => dispatch(setEffectCollapsed(id, isCollapsed)),
        setSelectedEffect: (id) => dispatch(setSelectedEffect(id)),
        setPulledEffects: e => dispatch(setPulledEffects(e)),
        setLinkingEffects: e => dispatch(setLinkingEffects(e)),
        setStarred: s => dispatch(setEffectStarred(props.effect.id, s)),
        clearDragDrop: s => dispatch(clearDragDrop(s))
    }
};

const mapStateToProps = (state, props) => {
    return {
        planeMapping: state.effects.planeMapping,
        effectDragging: state.sequencer.effectDragging,
        midiEffectDragging: state.effects.midiEffectDragging,
        isCollapsed: state.effects.effectCollapsed[props.effect.id],
        isSelected: state.effects.selectedEffect === props.effect.id,
        isEnabled: props.effect.isEnabled(),
        linkingEffects: state.effects.linkingEffects,
        isStarred: state.effects.effectStarred[props.effect.id],
        isSelectedZObject: props.effect === state.zobject.selectedZObject,
        preset: props.effect.preset
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DeletableEffectComponent);
